<template>
  <div class="pc-menu">
    <router-link
      v-for="menuItem in menuList"
      :id="menuItem.id || null"
      :key="menuItem.routeName"
      class="pc-menu__link"
      active-class="pc-menu__link--active"
      exact-path
      :data-test="menuItem.qaSlug"
      :to="{ name: menuItem.routeName }"
    >
      <template v-if="menuItem.id === 'my-plants'">
        <a-badge :count="myNewPlantsCount">
          {{ menuItem.title }}
        </a-badge>
      </template>
      <template v-else>
        {{ menuItem.title }}
      </template>
    </router-link>

    <!-- <button
      type="button"
      class="pc-menu__contact-btn"
      data-test="header-contact-us-link"
      @click="openContactUsModal"
    > 
      {{ $t("page_contact_us_head_title") }}
    </button> -->

    <div
      v-if="user?.subscription?.is_premium"
      class="pc-menu__pricing-btn pc-menu__pricing-btn--premium-upgrade"
      data-test="header-upgrade-to-pro-link"
    >
      <img src="@/assets/crown-purple.svg" alt="premiumIcon" />
      {{ $t('form_button_premium') }}
    </div>

    <router-link
      v-else
      class="pc-menu__pricing-btn pc-menu__pricing-btn--upgrade"
      :to="{ name: 'Pricing' }"
      data-test="header-upgrade-to-pro-link"
      exact-path
    >
      <img src="@/assets/crown.svg" alt="premiumIcon" />
      {{ $t('form_button_get_premium') }}
    </router-link>

    <button
      v-if="userEmpty"
      class="pc-menu__login-btn"
      type="button"
      data-test="header-join-btn"
      @click="showLoginModal"
    >
      {{ $t('form_button_log_in') }}
    </button>

    <UserMenu v-else />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { Badge } from 'ant-design-vue';
import UserMenu from './UserMenu.vue';

export default {
  name: 'PcMenu',

  components: {
    UserMenu,
    ABadge: Badge,
  },

  computed: {
    ...mapGetters('auth', ['userEmpty', 'user']),
    ...mapState('my-plants', ['myNewPlantsCount']),
    menuList() {
      return this.userEmpty
        ? [
            {
              title: this.$t('page_home_head_title'),
              routeName: 'Home',
              qaSlug: 'header-home-link',
            },
            {
              title: this.$t('page_explore_plants_head_title'),
              routeName: 'ExplorePlants',
              qaSlug: 'header-explore-plants-link',
            },
            {
              title: this.$t('page_my_plants_head_title'),
              routeName: 'MyPlants',
              qaSlug: 'header-my-plants-link',
              id: 'my-plants',
            },
            {
              title: this.$t('page_calendar_head_title'),
              routeName: 'Calendar',
              qaSlug: 'header-calendar-link',
            },
          ]
        : [
            {
              title: this.$t('page_home_head_title'),
              routeName: 'Home',
              qaSlug: 'header-home-link',
            },
            {
              title: this.$t('page_explore_plants_head_title'),
              routeName: 'ExplorePlants',
              qaSlug: 'header-explore-plants-link',
            },
            {
              title: this.$t('page_my_plants_head_title'),
              routeName: 'MyPlants',
              qaSlug: 'header-my-plants-link',
              id: 'my-plants',
            },
            {
              title: this.$t('page_calendar_head_title'),
              routeName: 'Calendar',
              qaSlug: 'header-calendar-link',
            },
          ];
    },
  },

  methods: {
    openContactUsModal() {
      this.$store.dispatch('base/openModal', 'ContactUs');
    },
    showLoginModal() {
      this.$store.dispatch('base/openModal', 'Authorization');
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-menu {
  $this: 'pc-menu';
  display: flex;
  align-items: center;

  &__link {
    cursor: pointer;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0.75px;
    color: $primary_black;
    position: relative;
    margin-right: 24px;

    @include media('xl') {
      margin-right: 32px;
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      bottom: -24px;
      left: 0;
      width: 100%;
      height: 3px;
      background-color: transparent;
    }

    :deep(.ant-badge) {
      font-size: 15px;
      line-height: 24px;
    }

    &--active {
      color: $light_purple;

      &:after {
        background-color: $light_purple;
      }

      :deep(.ant-badge) {
        color: $light_purple;
      }
    }
  }

  &__contact-btn {
    cursor: pointer;
    background-color: transparent;
    border: 2px solid $light_purple;
    border-radius: 8px;
    padding: 4px 14px;
    font-size: 13px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: 0.25px;
    color: $light_purple;
  }

  &__pricing-btn {
    display: flex;
    align-items: center;
    border-radius: 8px;
    padding: 9px 16px;
    font-size: 13px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: 0.25px;
    margin-left: auto;
    margin-right: 24px;

    img {
      margin-right: 12px;
    }
  }

  &__pricing-btn--upgrade {
    background: #9252fa;
    color: #ffffff;
  }

  &__pricing-btn--premium-upgrade {
    background: #eff0f6;
    color: #000000;
    font-weight: 400;
  }

  &__login-btn {
    height: 32px;
    all: unset;
    color: #000000;
    cursor: pointer;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0.75px;
  }

  :deep(.ant-badge-count) {
    top: -8px;
    right: -8px;
    background-color: $light_purple;
  }
}
</style>
